// extracted by mini-css-extract-plugin
module.exports = {"w6ruzz9":"w6ruzz9"};